<template>
  <div class="flex flex-col flex-wrap">
    <DisplayStatAverageCoaches
      statName="taux de conversion"
      :statAverage="averageConversionRateCoaches"
      percentage
    />

    <div class="flex flex-col">
      <h3>
        TOP COACHS
        <i
          class="fa fa-info-circle ml-05"
          v-tooltip="{
            content: 'Coachs ayant un taux de conversion supérieur à 66%.',
            placement: 'top',
          }"
        ></i>
      </h3>
      <ConversionLevel
        id="successCoachs"
        type="success"
        :coachs="successCoachs"
      />
    </div>

    <div class="flex flex-col mt-3">
      <h3>
        MIDDLE COACHS
        <i
          class="fa fa-info-circle ml-05"
          v-tooltip="{
            content: 'Coachs ayant un taux de conversion entre 33% et 66%.',
            placement: 'top',
          }"
        ></i>
      </h3>
      <ConversionLevel
        id="warningCoachs"
        type="warning"
        :coachs="warningCoachs"
      />
    </div>

    <div class="flex flex-col mt-3">
      <h3>
        BAD COACHS
        <i
          class="fa fa-info-circle ml-05"
          v-tooltip="{
            content: 'Coachs ayant un taux de conversion inférieur à 33%.',
            placement: 'top',
          }"
        ></i>
      </h3>
      <ConversionLevel id="dangerCoachs" type="danger" :coachs="dangerCoachs" />
    </div>
  </div>
</template>

<script>
import DisplayStatAverageCoaches from "@/components/coach-manager/DisplayStatAverageCoaches";
import ConversionLevel from "@/components/coach-manager/conversion/ConversionLevel";
export default {
  components: {
    ConversionLevel,
    DisplayStatAverageCoaches,
  },

  props: {
    data: { type: Array, required: true },
    filters: {
      required: true,
      type: Object,
    },
    currentCoach: null,
  },

  computed: {
    successCoachs() {
      return this.data.filter((coach) => coach.tc >= 66);
    },
    warningCoachs() {
      return this.data.filter((coach) => coach.tc >= 33 && coach.tc < 66);
    },
    dangerCoachs() {
      return this.data.filter((coach) => coach.tc < 33);
    },

    averageConversionRateCoaches() {
      const totalCoaches = this.data.length;

      if (totalCoaches === 0) return 0;

      const totalConversionRate = this.data.reduce((sum, coach) => {
        return sum + coach.tc;
      }, 0);

      return (totalConversionRate / totalCoaches).toFixed(2);
    },
  },

  methods: {
    goToUser(id) {
      const route = this.$router.resolve({
        name: "user-details",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
